import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LKModal from '../../Modal/Modal';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import CartItems from './CartItems';
import * as cartActions from '../../../../actionCreators/cart';
import { hasFrameOnlyProduct } from '../../../../utils/helper';
import './Cart.scss';

class Cart extends Component {
    static propTypes = {
        cartData: PropTypes.any,
        addToCartFailed: PropTypes.any,
        isCartLoader: PropTypes.bool,
        redisCommonData: PropTypes.object,
        section: PropTypes.string,
        updateCartSuccess: PropTypes.bool,
        updateCartFail: PropTypes.bool,
        cartOmniture: PropTypes.func,
        isframeProduct: PropTypes.bool
    };
    constructor(props, context) {
        super(props, context);
        this.state = {
            showCart: true,
            dtmOnLoad: true,
            dtmRemoveOnLoad: true,
            checkoutLoader: false
        };
    }
    componentDidMount() {
        sessionStorage.setItem('dtmOnLoadData', 'cartSummaryInner');
        const { cartData, updateCartSuccess, updateCartFail, cartActions, cartOmniture } = this.props;
        const pageInfo = `page: ${document.location.pathname}${document.location.search} |time: Date()`;
        if (updateCartSuccess && sessionStorage.getItem('cartItem') === 'increase') {
            _gaq.push(['_trackEvent', 'A2C Popup', 'Update Qty Success', pageInfo]);
            _gaq.push(['ninja._trackEvent', 'A2C Popup', 'Update Qty Success', pageInfo]);
        } else if (updateCartFail && sessionStorage.getItem('cartItem') === 'increase') {
            _gaq.push(['_trackEvent', 'A2C Popup', 'Update Qty Failure', pageInfo]);
            _gaq.push(['ninja._trackEvent', 'A2C Popup', 'Update Qty Failure', pageInfo]);
        }
        if (updateCartSuccess && sessionStorage.getItem('cartItem') === 'decrease') {
            _gaq.push(['_trackEvent', 'A2C Popup', 'decrease Qty Success', pageInfo]);
            _gaq.push(['ninja._trackEvent', 'A2C Popup', 'decrease Qty Success', pageInfo]);
        } else if (updateCartFail && sessionStorage.getItem('cartItem') === 'decrease') {
            _gaq.push(['_trackEvent', 'A2C Popup', 'decrease Qty Failure', pageInfo]);
            _gaq.push(['ninja._trackEvent', 'A2C Popup', 'decrease Qty Failure', pageInfo]);
        }
        if (updateCartSuccess && sessionStorage.getItem('cartItem') === 'delete') {
            _gaq.push(['_trackEvent', 'A2C Popup', 'Remove Product Success', pageInfo]);
            _gaq.push(['ninja._trackEvent', 'A2C Popup', 'Remove Product Success', pageInfo]);
        } else if (updateCartFail && sessionStorage.getItem('cartItem') === 'delete') {
            _gaq.push(['_trackEvent', 'A2C Popup', 'Remove Product Success', pageInfo]);
            _gaq.push(['ninja._trackEvent', 'A2C Popup', 'Remove Product Success', pageInfo]);
        }
        const isframeProduct = hasFrameOnlyProduct(cartData.result.items);
        cartActions.frameOnlyProduct({ isframeProduct });
        if ((cartData.result.id && this.state.dtmOnLoad && this.state.dtmRemoveOnLoad && sessionStorage.getItem('dtmOnLoadData') !== 'cartSummary')) {
            cartOmniture(cartData.result.items);
        }
        if (typeof window.clevertap !== 'undefined') {
            window.clevertap.event.push('Page Visited', {
                pageName: 'Cart Page'
            });
        }
    }

    componentDidUpdate(prevProps) {
        const { cartData, cartActions, cartOmniture } = this.props;
        if ((cartData.result.id && this.state.dtmOnLoad && this.state.dtmRemoveOnLoad && sessionStorage.getItem('dtmOnLoadData') !== 'cartSummary')) {
            cartOmniture(cartData.result.items);
        }
        if (prevProps.cartData !== cartData) {
            const isframeProduct = hasFrameOnlyProduct(cartData.result.items);
            cartActions.frameOnlyProduct({ isframeProduct });
        }
        sessionStorage.setItem('cartItem', '');
    }

    dtmStateLoad = flag => {
        this.setState({ dtmRemoveOnLoad: flag });
    }
    checkoutLoaderFunc = bool => {
        const scriptEl = document.querySelector('#yotpo_widget_lk');
        if (scriptEl) {
            document.head.removeChild(scriptEl);
        }
        this.setState({ checkoutLoader: bool });
        this.props.hideHandler();
    }
    footerClickHandler = () => {
        _gaq.push(['_trackEvent', 'Place Order', 'Cod'], ['ninja._trackEvent', 'Place Order', 'Cod']);
        this.checkoutLoaderFunc(true);
    }

    emptyCartView = () => {
        const { dataLocale: { SEARCH_FOR, CONTACT_LENSES, SUNGLASSES, EYEGLASSES, CONTINUE_SHOPPING, THERE_IS_PROBLEM_ADDING_ITEM, YOUR_SHOPPING_CART_EMPTY, SHOP_FOR_PRODUCTS_ADD_ITEMS } } = this.props;
        return (
            <div className="cart-popup_slide_empty">
                <span className="cart-popup_slide_empty_message">
                    {this.props.addToCartFailed &&
                        this.props.addToCartFailed.message
                        ? <span>{THERE_IS_PROBLEM_ADDING_ITEM} <span className="hidden">{this.props.addToCartFailed.message}</span></span>
                        : YOUR_SHOPPING_CART_EMPTY}
                </span>
                <div>{SHOP_FOR_PRODUCTS_ADD_ITEMS}</div>
                <div className="cart-popup_slide_empty_footer">
                    <a
                        title={CONTINUE_SHOPPING}
                        className="title"
                        href={typeof window !== 'undefined' && window.location.origin}
                    >
                        <span className="text-uppercase">{CONTINUE_SHOPPING}</span>{' '}
                        <i className="icon-chkout-arw" />
                    </a>
                </div>
                <div className="cart-popup_slide_empty_links row-fluid f18">
                    <div className="span2 bold">{SEARCH_FOR}:</div>
                    <div className="span3 color-yellow">
                        <a href={typeof window !== 'undefined' && `${window.location.origin}/eyeglasses.html`}>{EYEGLASSES}</a>
                    </div>
                    <div className="span3 color-yellow">
                        <a href={typeof window !== 'undefined' && `${window.location.origin}/sunglasses.html`}>{SUNGLASSES}</a>
                    </div>
                    <div className="span3 color-yellow">
                        <a href={typeof window !== 'undefined' && `${window.location.origin}/contact-lenses.html`}>{CONTACT_LENSES}</a>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { cartData, isCartLoader, hideHandler, redisCommonData, isframeProduct, dataLocale } = this.props;
        const { SHOPPING_CART } = dataLocale;
        return (
            <div>
                <LKModal size="large" backdrop keyboard hideHandler={hideHandler} showModal={this.state.showCart} dialogClassName="cart-popup">
                    <div className="cart-popup_slide row" style={{ overflow: 'hidden' }}>
                        <div className="cart-popup_slide_header">
                            <i className="icon-cart-close" onClick={hideHandler} />
                            <h4 className="title col-sm-6">{SHOPPING_CART} ({cartData.result.itemsCount}) </h4>
                        </div>

                        {isCartLoader && <div className="text-center"><img
                            src="https://static.lenskart.com/media/desktop/img/loader-lk.gif"
                            alt="loader"
                        /></div>}

                        {/* render cart items */}
                        {!isCartLoader && (cartData.result.itemsQty !== 0
                            ? <CartItems {...this.props} isframeProduct={isframeProduct} redisCommonData={redisCommonData} cartObj={cartData.result} dtmStateLoad={this.dtmStateLoad} checkoutLoaderFunc={bool => { this.checkoutLoaderFunc(bool); }} checkoutLoader={this.state.checkoutLoader} />
                            : this.emptyCartView())}

                    </div>
                </LKModal>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    isCartLoader: state.cart.isCartLoader,
    isAlreadyLoyal: state.common.isAlreadyLoyal,
    cartData: state.cart.cartData,
    updateCartSuccess: state.cart.updateCartSuccess,
    updateCartFail: state.cart.updateCartFail,
    addToCartFailed: state.cart.addToCartFailed,
    section: state.common.section,
    isframeProduct: state.cart.isframeProduct,
    redisCommonData: state.common.redisCommonData,
    login: state.common.login,
    cartCampaign: state.campaign.cartCampaign,
    cartBogoConfig: state.campaign.cartBogoConfig,
    dataLocale: state.locale
});

function mapDispatchToProps(dispatch) {
    return {
        cartActions: bindActionCreators(cartActions, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Cart);
